<template>
    <FilterBase :title="title">
        <InputRangeSegmentedWithInputs
            v-model="model"
            :segments-config
            :min="bounds.min || 0"
            :max="bounds.max || 15"
            :step="0.05"
            :value-formatter
            :debounce="500"
            :min-label
            :max-label
        />
    </FilterBase>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Bounds } from 'wucdbm-exponential-slider'

import type { GemsApi_RangeInput } from '@/graphql/api'

import FilterBase from '@/components/ui/filter/filters/layout/FilterBase.vue'
import type {
    InputRangeModel,
    InputRangeTwoKnobbedValueFormatter,
} from '@/components/ui/inputs/range/input-range-two-knobbed-props.ts'
import InputRangeSegmentedWithInputs from '@/components/ui/inputs/range/InputRangeSegmentedWithInputs.vue'
import type { SegmentConfig } from '@/components/ui/inputs/range/input-range-segmented'

interface Props {
    modelValue?: GemsApi_RangeInput | null | undefined
    bounds: Bounds
    step?: number
    title?: string
    valueFormatter?: InputRangeTwoKnobbedValueFormatter
    minLabel: string
    maxLabel: string
    segmentsConfig: SegmentConfig
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: null,
    step: 1,
    valueFormatter: undefined,
    title: undefined,
})

const emit = defineEmits<{
    'update:modelValue': [input: GemsApi_RangeInput]
}>()

const model = computed({
    get: (): InputRangeModel => [props.modelValue?.min, props.modelValue?.max],
    set: (v: InputRangeModel) => {
        emit('update:modelValue', {
            min: v[0],
            max: v[1],
        })
    },
})
</script>
